<template>
  <div>
    <b-container fluid>
      <template v-if="activePhase == 1">
        <b-row class="mb-1">
          
        <b-col xs="12" sm="12" md="12" lg="5" class="section__center-col">
          <p class="section__title section__margin-two-bottom">
            Seleccione el método de ingreso de datos
          </p>
          <b-button
           
            @click="goToStep(2)"
            block
            class="section__button_rounded"
          >
            Nota de Venta
          </b-button>
          <b-button
            
            @click="goToStep(3)"
            block
            class="section__button_rounded"
          >
            Manual
          </b-button>
        </b-col>
      
        </b-row>
        
        <b-row>
          <b-col lg="6" class="padding-left-none">
            <b-button
              class="width-100 bg-white btn-white-v border-black-all color-gray"
              @click="closeModalEdit"
            >
              Cancelar
            </b-button>
          </b-col>
          
        </b-row>
      </template>
      <template v-if="activePhase == 2">
        <b-row class="padding-two-bottom">
          <nota-venta :idProject="idProject" v-bind:showCambiarFlujo="'hidden'" >
          </nota-venta>
        </b-row>
        <b-row>
          <b-col lg="6" class="padding-left-none">
            <b-button
              class="width-100 bg-white btn-white-v border-black-all color-gray"
              @click="goToStep(1)"
            >
              Retroceder
            </b-button>
          </b-col>
         
        </b-row>
      </template>
      <template v-if="activePhase == 3">
       
        <b-row>
         <Manual :idProject="idProject" v-bind:showCambiarFlujo="'hidden'" />
        </b-row>
        <b-row>
          <b-col lg="6" class="padding-left-none">
            <b-button
              class="width-100 bg-white btn-white-v border-black-all color-gray"
              @click="goToStep(1)"
            >
              Retroceder
            </b-button>
          </b-col>
        </b-row>
      </template>
      <!--  <b-row >
        <b-col lg="6" class="padding-left-none">
          <b-button
            class="width-100 bg-white btn-white-v border-black-all color-gray"
            @click="closeModalEdit"
          >
            Cancelar
          </b-button>
        </b-col>
        <b-col lg="6" class="padding-rigth-none">
          <b-button class="btn-dark width-100" :disabled="isEnableUpdate" @click="updateRoute">
            Guardar
          </b-button>
        </b-col>
      </b-row> -->
    </b-container>
  </div>
</template>

<script>
import axios from "axios";
import { mapState } from "vuex";
import NotaVenta from "../../views/crearOS/NotaVenta.vue"
import Manual from "../../views/crearOS/Manual.vue"
//import Photos from "./Photos.vue";
export default {
  name: "ModalEdit",

  data() {
    return {
      activePhase: 1,
      optionStates: [],
      selectedState: { idTypeMotive: null, idState: null },
      optionSubstate: [],
      selectedSubState: "",
      observation: "",
      isDragging: false,
      files: [],
      imageBase: [],
      photos: [],
      filename: "",
      technicianName: "",
      dniTechnical: "",
    };
  },
 
  components:{NotaVenta,Manual},
  computed: {
    ...mapState("module", ["username","perfil"]),
    isEnableUpdate() {
      if (this.files.length >= 2 ) return false;
      return true;
    },
    validateFields() {
      if (this.selectedState.idTypeMotive && this.selectedSubState)
        return false;
      return true;
    },
  },
  props: {
    orderService: {
      type: String,
    },
    idRoute: {
      type: Number,
    },
    idService: {
      type: Number,
    },
    typeOs: {
      type: String,
    },
    idOsDet: {
      type: Number,
    },
    clientName: {
      type: String,
    },
    store: {
      type: String,
    },
    idProject:{
      type:Number
    }
  },
  created() {
    this.getStates();
  },
  methods: {
    goToStep(step) {
      this.activePhase = step;
    },
    remove(i) {
      this.files.splice(i, 1);
    },
    onChange() {
      let filesArr = this.$refs.file.files;
      let file = filesArr[0];
      this.files.push(file);
      //this.files = [...this.$refs.file.files];
    },
    dragover(e) {
      e.preventDefault();
      this.isDragging = true;
    },
    dragleave() {
      this.isDragging = false;
    },
    drop(e) {
      e.preventDefault();
      this.$refs.file.files = e.dataTransfer.files;
      this.onChange();
      this.isDragging = false;
    },
    closeModalEdit() {
      this.$emit("update:modalShowEdit", false);
    },
    getTimestamp() {
      return new Date().getTime();
    },
    async getFile(file) {
      //const file = this.files[0];
      let time = this.getTimestamp();
      const reader = new FileReader();
      return new Promise((resolve) => {
        reader.onload = (ev) => {
          let data = {
            src: ev.target.result,
            filename: time + file.name,
          };
          resolve(data);
        };
        reader.readAsDataURL(file);
      });
    },
    async uploadImageRoute() {
      try {
        let response = await axios.post(
          process.env.VUE_APP_BASE_ONETRACK + "/route/photo",
          this.photos,
          {
            headers: {
              "Content-type": "application/json",
            },
          }
        );
        console.log(response);
        this.$bvModal.hide("modal-photos");
      } catch (e) {
        console.log(e);
        this.sendAlert("danger", e.message);
      }
    },
    async uploadImage() {
      this.$store.commit("SET_LOADING", true);
      const listSrc = [];
      for (var i = 0; i < this.files.length; i++) {
        let res = await this.getFile(this.files[i]);
        console.log(res);
        listSrc.push({
          src: res.src,
          filename: res.filename,
        });
      }
      try {
        for (var x = 0; x < listSrc.length; x++) {
          let response = await axios.post(
            process.env.VUE_APP_BASE_ONETRACK_EXT + "/upload-photo",
            {
              user: this.username,
              image: listSrc[x].src,
              type: "photo",
              filename: listSrc[x].filename,
            }, // the data to post
            {
              headers: {
                "Content-type": "application/json",
              },
            }
          );
          this.photos.push({
            idRoute: this.idRoute,
            idOsDet: 100,
            photoUrl: response.data.imageUrl,
            username: this.username,
          });
        }
      } catch (error) {
        this.sendAlert("danger", error.response.data.message);
      } finally {
        setTimeout(() => {
          this.$store.commit("setShowAlert", false);
        }, 3000);
      }
      await this.uploadImageRoute();
      this.goToStep(3);
      this.$store.commit("SET_LOADING", false);
    },
    sendAlert(variant, msg) {
      this.$store.commit("setShowAlert", true);
      this.$store.commit("SET_ERROR_MSG", { variant: variant, msg: msg });
    },
    async updateRoute() {
      try {
        this.$store.commit("SET_LOADING", true);
        let response = await axios.put(
          process.env.VUE_APP_BASE_ONETRACK + "/route/" + this.idService,
          {
            userModification: this.username,
            state: this.selectedState.idState,
            subState: this.selectedSubState,
            clientDni: "",
            clientName: this.clientName,
            observationsOptional: this.observation,
            missingPartsOptional: "",
          }, // the data to post
          {
            headers: {
              "Content-type": "application/json",
            },
          }
        );
        console.log(response);
        if (this.typeOs == "VTEC") {
          this.createReportVtec();
        } else if (this.typeOs == "VINS") {
          this.createReportVIns();
        }
        this.$emit("refreshData", true);
        this.sendAlert("success","Se actualizó exitosamente !")
      } catch (error) {
        this.sendAlert("danger",error.response.data.message)
        console.log(error);
      } finally {
        this.$store.commit("SET_LOADING", false);
        setTimeout(() => {
          this.$store.commit("setShowAlert", false);
          this.closeModalEdit();
        }, 3000);
      }
    },
    async createReportVIns() {
      let response = await axios.post(
        process.env.VUE_APP_BASE_MOTIVOS_EXT + "/ivr",
        {
          clientName: this.clientName,
          customerDni: "",
          codeStore: this.store,
          idOsDet: this.idOsDet,
          idRoute: this.idRoute,
          numberOs: this.orderService,
          technicianName: this.username,
          technicianDni: this.username,
          technicalReport: "",
          report: "",
          recommendations: "",
        }, // the data to post
        {
          headers: {
            "Content-type": "application/json",
          },
        }
      );
      console.log(response);
    },
    async createReportVtec() {
      let response = await axios.post(
        process.env.VUE_APP_BASE_MOTIVOS_EXT + "/tvr",
        {
          clientName: this.clientName,
          dniClient: "",
          codeStore: this.store,
          idOsDet: this.idOsDet,
          idRoute: this.idRoute,
          numOs: this.orderService,
          technicianName: this.username,
          dniTechnical: this.username,
          observationsArea: "",
          detailServices: "",
          observationsAdditional: "",
        }, // the data to post
        {
          headers: {
            "Content-type": "application/json",
          },
        }
      );
      console.log(response);
    },
    async getStates() {
      try {
        let response = await axios.get(
          process.env.VUE_APP_BASE_ONETRACK_STATE + "/state"
        );
        const data = response.data.map((row) => {
          return {
            value: {
              idTypeMotive: row.idTypeMotive,
              idState: row.idState,
              description: row.descripcionState,
            },
            text: row.descripcionState,
          };
        });
        this.optionStates = data;
      } catch (e) {
        console.log(e);
      }
    },
    async getSubstates() {
      try {
        if (!this.selectedState.idTypeMotive) return;
        let response = await axios.get(
          process.env.VUE_APP_BASE_MOTIVOS +
            "/motives/v2?responsible=13&type=" +
            this.selectedState.idTypeMotive
        );
        const data = response.data.map((row) => {
          return {
            value: row.id,
            text: row.description,
          };
        });
        this.optionSubstate = data;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<style scoped>
.btn-white-v:hover {
  color: white !important;
  background: #626262 !important ;
}
.btn-dark {
  background-color: #405568 !important;
  border-color: #405568 !important;
  color: white;
  border-radius: 4px;
}
.btn-dark:hover {
  background-color: white !important;
  border-color: #405568 !important;
  color: #405568;
  border-radius: 4px;
}
.border-all {
  border: 1px solid #d8d8d8 !important;
}
.padding-three-top {
  padding-top: 2%;
}
.border-dashed {
  border: 1px dashed #f7f7f7;
  border-radius: 6px;
}
.btn-blue {
  background-color: #1b8cf3 !important;
  color: white !important;
  border-color: #1b8cf3 !important;
  border-radius: 4px;
}
.btn-blue:hover {
  color: #1b8cf3 !important;
  background: white !important ;
}

.dropzone-container {
  padding: 2.5rem;
  background: #fafafa;
  border: 1px dashed #c0c0c0;
}

.hidden-input {
  opacity: 0;
  overflow: hidden;
  position: absolute;
  width: 1px;
  height: 1px;
}

.file-label {
  font-size: 20px;
  display: block;
  cursor: pointer;
}

.preview-container {
  display: flex;
  margin-top: 2rem;
}

.preview-card {
  display: flex;
  border: 1px solid #a2a2a2;
  padding: 5px;
  margin-left: 5px;
}

.preview-img {
  width: 50px;
  height: 50px;
  border-radius: 5px;
  border: 1px solid #a2a2a2;
  background-color: #a2a2a2;
}
.badge {
  border-radius: none !important;
  background-color: transparent !important;
  color: #686868 !important;
}
.list-group-item {
  border: none !important;
}
.border-all-green {
  border: 1px solid #19be2b;
}
.vertical-align-middle {
  display: table-cell !important;
  vertical-align: middle !important;
}
.center-div {
  float: none;
  margin-left: auto;
  margin-right: auto;
  text-align: center;
}
</style>
